import React from "react";

import { FormControl, Grid } from "lib/index";
import createCompanySettingsView from "modules/settings/createCompanySettingsView";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./BillingSettingsHint";

const FormContent = ({ company, errors, handleCompanyPropChange }) => (
  <div>
    <h3>{I18n.t("papp.settings.BillingSettingsView.invoice_details_title")}</h3>

    <Grid>
      <Grid.Column width={12}>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_company_name`, { errors })}
          value={company.invoice_company_name}
          onChange={handleCompanyPropChange.bind(null, "invoice_company_name")}
          label={I18n.humanAttributeName("company", "invoice_company_name")}
          placeholder={I18n.t("papp.settings.BillingSettingsView.invoice_company_name_placeholder", {
            default_value: company.name,
          })}
        />
      </Grid.Column>
      <Grid.Column width={4}>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_nip`, { errors })}
          value={company.invoice_nip}
          onChange={handleCompanyPropChange.bind(null, "invoice_nip")}
          label={I18n.humanAttributeName("company", "invoice_nip")}
        />
      </Grid.Column>
    </Grid>

    <FormControl.InputFormGroup
      {...FormControl.addProps(`model.invoice_street_address`, { errors })}
      value={company.invoice_street_address}
      onChange={handleCompanyPropChange.bind(null, "invoice_street_address")}
      label={I18n.humanAttributeName("company", "invoice_street_address")}
      wrapperClassName="u-marginVertical"
    />

    <Grid columns={3}>
      <Grid.Column>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_postal_code`, { errors })}
          value={company.invoice_postal_code}
          onChange={handleCompanyPropChange.bind(null, "invoice_postal_code")}
          label={I18n.humanAttributeName("company", "invoice_postal_code")}
        />
      </Grid.Column>
      <Grid.Column>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_city`, { errors })}
          value={company.invoice_city}
          onChange={handleCompanyPropChange.bind(null, "invoice_city")}
          label={I18n.humanAttributeName("company", "invoice_city")}
        />
      </Grid.Column>
      <Grid.Column>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_country_name`, { errors })}
          value={company.invoice_country_name}
          onChange={handleCompanyPropChange.bind(null, "invoice_country_name")}
          label={I18n.humanAttributeName("company", "invoice_country_name")}
          nullValue={I18n.t("papp.common.poland")}
        />
      </Grid.Column>
    </Grid>

    <Grid columns={2}>
      <Grid.Column>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_email`, { errors })}
          value={company.invoice_email}
          onChange={handleCompanyPropChange.bind(null, "invoice_email")}
          label={I18n.humanAttributeName("company", "invoice_email")}
          placeholder={I18n.t("papp.settings.BillingSettingsView.invoice_contact_email_placeholder", {
            default_value: company.contact_email || I18n.t("papp.common.none"),
          })}
        />
      </Grid.Column>
      <Grid.Column>
        <FormControl.InputFormGroup
          {...FormControl.addProps(`model.invoice_phone_number`, { errors })}
          value={company.invoice_phone_number}
          onChange={handleCompanyPropChange.bind(null, "invoice_phone_number")}
          label={I18n.humanAttributeName("company", "invoice_phone_number")}
          placeholder={I18n.t("papp.settings.BillingSettingsView.invoice_contact_phone_number_placeholder", {
            default_value: company.contact_phone_number || I18n.t("papp.common.none"),
          })}
        />
      </Grid.Column>
    </Grid>
  </div>
);

const BillingSettingsView = createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.BillingSettingsView.title"),
  FormContent,
  Hint,
});

export default BillingSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/BillingSettingsView/BillingSettingsView.jsx